"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncDropdownBasicProps = void 0;
const react_1 = __importStar(require("react"));
const Async_1 = __importDefault(require("react-select/lib/Async"));
const AsyncCreatable_1 = __importDefault(require("react-select/lib/AsyncCreatable"));
const debounce_promise_1 = __importDefault(require("debounce-promise"));
const prop_types_1 = __importDefault(require("prop-types"));
require("../../../styles/components/react-select/react-select.less");
const AsyncDropdownSelector = ({ asyncFunc, waitDebounce, disableOnFirstLoad, isCreatable, innerRef, ...otherProps }) => {
    const [isDisabled, setIsDisabled] = (0, react_1.useState)(disableOnFirstLoad);
    const loadOptions = (0, react_1.useMemo)(() => (0, debounce_promise_1.default)(async (inputValue) => {
        const res = await asyncFunc(inputValue);
        setIsDisabled(false);
        return res;
    }, waitDebounce), [asyncFunc, waitDebounce]);
    const props = {
        loadOptions,
        cacheOptions: true,
        ...otherProps,
    };
    if (isCreatable) {
        return react_1.default.createElement(AsyncCreatable_1.default, { ...props, isDisabled: isDisabled, ref: innerRef });
    }
    return react_1.default.createElement(Async_1.default, { ...props, ref: innerRef });
};
exports.AsyncDropdownBasicProps = {
    onChange: prop_types_1.default.func.isRequired,
    className: prop_types_1.default.string,
    classNamePrefix: prop_types_1.default.string,
    waitDebounce: prop_types_1.default.number,
    components: prop_types_1.default.object,
    showOnTop: prop_types_1.default.bool,
    styles: prop_types_1.default.object,
    noOptionsMessage: prop_types_1.default.func,
    defaultOptions: prop_types_1.default.oneOfType([
        prop_types_1.default.bool,
        prop_types_1.default.array,
    ]),
};
/* eslint-disable react/default-props-match-prop-types */
AsyncDropdownSelector.defaultProps = {
    className: '',
    classNamePrefix: 'react-select-dropdown',
    waitDebounce: 500,
    disableOnFirstLoad: true,
    components: {},
    noOptionsMessage: () => ('No Options'),
    defaultOptions: true,
    showOnTop: false,
    styles: {},
};
AsyncDropdownSelector.propTypes = {
    asyncFunc: prop_types_1.default.func.isRequired,
    disableOnFirstLoad: prop_types_1.default.bool,
    ...exports.AsyncDropdownBasicProps,
};
exports.default = AsyncDropdownSelector;
//# sourceMappingURL=async-dropdown.js.map